import { type FC } from "react";

import { ColoredLabel } from "widgets";

import { getGeneTypeColor } from "../../../../app-utils/color.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

export const getGeneTypeDisplayValue = (type: string) => (
  <ColoredLabel color={getGeneTypeColor(type)}>{type}</ColoredLabel>
);

const GeneTypeCell: FC<IAgGridCellProps> = ({ value }) => {
  if (!value) return null;

  return (
    <TableCell>
      <ColoredLabel color={getGeneTypeColor(value)}>{value}</ColoredLabel>
    </TableCell>
  );
};

export { GeneTypeCell };
export default GeneTypeCell;
